<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-row align="center" justify="center">
        <!-- Ecotron -->
        <v-col cols="12" sm="12" md="10">
          <device-list-data-table
            :devices="ecotronList"
            :pagination="ecotronPagination"
            deviceType="ecotron"
            :loading="ecotronLoading"
            @page-changed="onEcotronPageChanged"
            @limit-changed="onEcotronLimitChanged"
            @search="onEcotronSearch"
          />
        </v-col>

        <!-- Ecofrost -->
        <v-col cols="12" sm="12" md="10">
          <device-list-data-table
            :devices="ecofrostList"
            :pagination="ecofrostPagination"
            deviceType="ecofrost"
            :loading="ecofrostLoading"
            @page-changed="onEcofrostPageChanged"
            @limit-changed="onEcofrostLimitChanged"
            @search="onEcofrostSearch"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DeviceListDataTable from '../components/DeviceListDataTable';
import NavBar from '../components/NavBar';

export default {
  name: 'home',
  components: {
    NavBar,
    DeviceListDataTable
  },
  data() {
    return {
      // ecotronLoading: false,
      // ecofrostLoading: false,
      ecotronSearchText: '',
      ecofrostSearchText: ''
    };
  },
  computed: {
    ...mapState('ecotron', {
      ecotronList: 'ecotronList',
      ecotronPagination: 'ecotronPagination',
      ecotronLoading: 'ecotronLoading'
    }),

    ...mapState('ecofrost', {
      ecofrostList: 'ecofrostList',
      ecofrostPagination: 'ecofrostPagination',
      ecofrostLoading: 'ecofrostLoading'
    })
  },
  methods: {
    ...mapActions({
      fetchEcotronList: 'ecotron/fetchEcotronList',
      fetchEcofrostList: 'ecofrost/fetchEcofrostList'
    }),

    async onEcotronPageChanged(newPage) {
      try {
        await this.fetchEcotronList({
          page: newPage,
          limit: this.ecotronPagination.limit,
          search: this.ecotronSearchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async onEcotronLimitChanged(newLimit) {
      try {
        await this.fetchEcotronList({
          page: 1,
          limit: newLimit,
          search: this.ecotronSearchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async onEcotronSearch(searchText) {
      try {
        this.ecotronSearchText = searchText;
        await this.fetchEcotronList({
          page: 1,
          limit: this.ecotronPagination.limit,
          search: searchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async onEcofrostPageChanged(newPage) {
      try {
        await this.fetchEcofrostList({
          page: newPage,
          limit: this.ecofrostPagination.limit,
          search: this.ecofrostSearchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async onEcofrostLimitChanged(newLimit) {
      try {
        await this.fetchEcofrostList({
          page: 1,
          limit: newLimit,
          search: this.ecofrostSearchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async onEcofrostSearch(searchText) {
      try {
        this.ecofrostSearchText = searchText;
        await this.fetchEcofrostList({
          page: 1,
          limit: this.ecofrostPagination.limit,
          search: searchText
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  },

  async created() {
    this.$store.commit('setError', false);
    try {
      await this.fetchEcotronList({ page: 1, limit: 10 });
      await this.fetchEcofrostList({ page: 1, limit: 10 });
    } catch (error) {
      if (error.isAxiosError) {
        this.$store.commit('setError', error.response.data.error.message);
      } else {
        this.$store.commit('setError', error);
      }
    }
  }
};
</script>
